<app-no-scopes-message *ngIf="missingAllRequiredScopes">
    To display the skills page, you need to grant the "Read skills" scope.
</app-no-scopes-message>

<div class="container skills-page-container" *ngIf="missingAllRequiredScopes === false">
    <div class="skill-points-container">
        <div>
            <h2>Skillpoints</h2>
            <p class="skill-points" *ngIf="skills">
                {{ totalSP | number:'1.0-0' }} SP
                <span class="unallocated text-info" *ngIf="skills?.unallocated_sp">
                    + ({{ skills?.unallocated_sp | number:'1.0-0' }} unallocated SP)
                </span>
            </p>
        </div>
        <div class="training-speed" *ngIf="hasSkillQueueScope">
            <h2>Training speed</h2>
            <span *ngIf="skills">
                {{ spPerSec * 60 | number:'1.0-2' }} SP/min
            </span>
        </div>
    </div>

    <div class="attributes-container justify-content-evenly" *ngIf="hasSkillsScope">
        <div class="attribute" [ngbTooltip]="'Perception'">
            <img src="/assets/images/22_32_1.png" alt="Perception">
            <p>{{ attributes?.perception }}</p>
        </div>
        <div class="attribute" [ngbTooltip]="'Memory'">
            <img src="/assets/images/22_32_2.png" alt="Memory">
            <p>{{ attributes?.memory }}</p>
        </div>
        <div class="attribute" [ngbTooltip]="'Willpower'">
            <img src="/assets/images/22_32_3.png" alt="Willpower">
            <p>{{ attributes?.willpower }}</p>
        </div>
        <div class="attribute" [ngbTooltip]="'Intelligence'">
            <img src="/assets/images/22_32_4.png" alt="Intelligence">
            <p>{{ attributes?.intelligence }}</p>
        </div>
        <div class="attribute" [ngbTooltip]="'Charisma'">
            <img src="/assets/images/22_32_5.png" alt="Charisma">
            <p>{{ attributes?.charisma }}</p>
        </div>
    </div>

    <hr>

    <div class="skill-queue-container" *ngIf="hasSkillQueueScope">
        <div class="d-flex justify-content-between">
            <h2>Skill queue ( {{ skillQueueCount }} )</h2>
            <h2 (click)="skillQueueVisible = !skillQueueVisible"><fa-icon [icon]="faChevronDown"></fa-icon></h2>
        </div>
        <p class="skill-queue-time" *ngIf="!skillTrainingPaused" [ngClass]="{'text-warning': hasLowSkillQueue}">
            <span *ngIf="hasLowSkillQueue"><fa-icon [icon]="faExclamationTriangle"></fa-icon></span>
            Skill queue ends in {{ totalQueueCountdown }}
        </p>
        <div class="skill-queue" *ngIf="skillQueueVisible">
            <ng-container *ngIf="skillTrainingPaused">
                <p class="stalled"><fa-icon [icon]="faCog"></fa-icon> Skill queue inactive</p>
            </ng-container>
            <ng-container *ngIf="skillQueue.length && skills">
                <ng-container *ngFor="let skill of skillQueue">
                    <div class="skill-in-queue {{skill.status}}" *ngIf="skill.status !== 'finished'">
                        <div class="left-info">
                            <p>
                                <ng-container *ngIf="skill.status === 'training'">
                                    <fa-icon [icon]="faCog" [spin]="true"></fa-icon>
                                </ng-container>
                                <ng-container *ngIf="skill.status === 'scheduled'">
                                    <fa-icon [icon]="faClock" title="scheduled"></fa-icon>
                                </ng-container>
                                <strong>
                                    {{ skill.name }}
                                    <span class="text-info">
                                        {{ romanize(skill.finished_level) }}
                                    </span>
                                </strong>
                            </p>
                            <p class="skill-info">SP left {{ skill.spLeft | number:'1.0-0' }}</p>
                            <p *ngIf="skill.status === 'training'" class="skill-info">
                                Finishes in {{ skill.countdown }}
                            </p>
                            <p *ngIf="skill.status === 'scheduled'" class="skill-info">
                                Will take {{ skill.countdown }}
                            </p>
                        </div>
                        <div class="right-info">
                            <p class="skill-group" *ngIf="skill.name">
                                <fa-icon [icon]="faFolderOpen"></fa-icon> {{ getSkillGroup(skill.skill_id) }}</p>
                            <p>Total SP when finished {{ skill.spAtEnd | number:'1.0-0' }}</p>
                            <p *ngIf="skill.status === 'training'">{{ skill.percentageDone || 0 | number:'1.2-2' }}%</p>
                        </div>
                    </div>
                    <p class="skill-progressbar" *ngIf="skill.percentageDone">
                        <ngb-progressbar [value]="skill.percentageDone" height="2px"></ngb-progressbar>
                    </p>
                </ng-container>
            </ng-container>
        </div>

        <hr>

    </div>

    <div class="skill-list-container" *ngIf="hasSkillsScope">
        <h2>
            Skill overview ( {{ skills?.skills.length || 0 }}
            <ng-container *ngIf="showUntrainedSkills">
                / {{ skillTypes?.length }}
            </ng-container>
            )
        </h2>
        <div class="d-flex justify-content-between">
            <h4>{{ countLvl5Skills() }} skills at level 5</h4>
            <div>
                <div class="btn-group btn-group-toggle">
                    <label class="btn-outline-primary" ngbButtonLabel>
                        <input type="checkbox" ngbButton [(ngModel)]="showUntrainedSkills">
                        <fa-icon [icon]="showUntrainedSkills ? faEye : faEyeSlash"></fa-icon>
                        Untrained skills
                    </label>
                </div>
            </div>
        </div>
        <div class="skill-list" *ngIf="skills">
            <ngb-accordion>
                <ngb-panel *ngFor="let group of skillGroups" [disabled]="!trainedSkillsGrouped[group.group_id]?.length && !showUntrainedSkills">
                    <ng-template ngbPanelTitle>
                        <div class="d-flex justify-content-between">
                            <span>
                                <fa-icon [icon]="faChevronDown"></fa-icon>
                                <strong> {{ group.name }}</strong>
                                (
                                {{ trainedSkillsGrouped[group.group_id]?.length }}
                                <ng-container *ngIf="showUntrainedSkills">
                                     / {{ skillsGrouped[group.group_id]?.length }}
                                </ng-container>
                                )
                            </span>
                            <span>
                                {{ getSPInGroup(group.group_id) | number:'1.0-0' }} SP
                            </span>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <p class="skill-name d-flex justify-content-between"
                           [ngClass]="{'text-muted': !trainedSkills[skill.type_id]}"
                           *ngFor="let skill of (showUntrainedSkills ? skillsGrouped[group.group_id] : trainedSkillsGrouped[group.group_id])">
                            <span
                                [ngClass]="{'text-primary': currentTrainingSkill === trainedSkills[skill.type_id]?.skill_id}">
                                {{ skill.name }}
                                <span *ngIf="trainedSkills[skill.type_id]" class="text-info">
                                    {{ romanize(trainedSkills[skill.type_id].trained_skill_level) || 'Injected' }}
                                    <span *ngIf="currentTrainingSkill === trainedSkills[skill.type_id].skill_id">
                                        <span class="text-primary">
                                        <fa-icon [icon]="faArrowAltRight"></fa-icon>
                                        </span>
                                        {{ romanize(trainedSkills[skill.type_id].trained_skill_level + 1) }}
                                    </span>
                                </span>
                            </span>
                            <span *ngIf="trainedSkills[skill.type_id]"
                                  [ngClass]="{'text-primary': currentTrainingSkill === trainedSkills[skill.type_id].skill_id}">
                                {{ (currentTrainingSkill === trainedSkills[skill.type_id].skill_id ? trainedSkills[skill.type_id].skillpoints_in_skill + (currentTrainingSPGain || 0) : trainedSkills[skill.type_id].skillpoints_in_skill) || 0 | number:'1.0-0' }}
                                <ng-container *ngIf="currentTrainingSkill === trainedSkills[skill.type_id].skill_id">/ {{ currentTrainingSPEnd | number:'1.0-0' }}</ng-container>
                                SP
                            </span>
                        </p>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>
    </div>
</div>
